import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Link } from 'react-router'
import bem from '../../../common/bem'
import { PageWrapper, PageContent, Searchbar, PageSection, HtmlHead, Footer } from '../../ui'

import 'whatwg-fetch'
import './SearchPage.scss'

export default class SearchPage extends Component {

  constructor() {
    super()

    this._sendQuery = this._sendQuery.bind(this)
    this._queryStatus = this._queryStatus.bind(this)
    this._queryParse = this._queryParse.bind(this)
    this._querySuccess = this._querySuccess.bind(this)
    this._queryError = this._queryError.bind(this)
  }

  static defaultProps = {
    curMenuState: false

  }

  static propTypes = {
    curMenuState: PropTypes.bool,
    headerRouteStruct: PropTypes.object,
    route: PropTypes.object,
    currentPath: PropTypes.string,
    onMenuClick: PropTypes.func
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  componentWillMount() {
    !this.props.curMenuState && this.props.onMenuChange && this.props.onMenuChange(null, true);
    this.setState({
      queryData: [],
      queryError: null
    })
    const { location } = this.props

    if(location.query.q) {
      this._sendQuery(location.query)
    }
  }

  componentWillUpdate(nextProps) {
    if(nextProps.location.query !== this.props.location.query) {
      this._sendQuery(nextProps.location.query)
    }
  }

  _sendQuery(query) {
    fetch(`${SLS_ES_PATH}?q=${query.q}`, {
        method: 'GET',
        mode: 'cors',
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      })
      .then(response => this._queryStatus(response))
      .then(response => this._queryParse(response))
      .then(response => this._querySuccess(response))
      .catch(err => this._queryError(err))
  }

  _queryStatus(response) {
    if(response.status >=200 && response.status < 300 && response.status !== 204) {
      return response
    }
    else {
      const error = new Error(response.statusText)
      error.response = response
      error.status = response.status
      throw error
    }
  }

  _queryParse(response) {
    return response.json()
  }

  _querySuccess(response) {
    this.setState({
      queryData: response.results.hits.hits || [],
      queryError: null
    })
  }

  _queryError(err) {
    this.setState({
      queryData: [],
      queryError: err
    })
  }

  _displayFound({ bemmer }) {
    const { queryData, queryError } = this.state

    return !queryData || queryData.length <=0 ?
        (
          <section className={bemmer.element('notfound')}>
            <h2>Results:</h2>
            <h4>{ queryError && queryError.message ? queryError.message : 'Error.' }</h4>
          </section>
        ):(
          <section className={bemmer.element('found')}>
            <h2>Results:</h2>
            <section className={bemmer.element('list')}>
              { this.state.queryData.map(record => {

                const lastUpdated = record._source ? new Date(record._source.last_updated) : null
                const description = record._source.description ? record._source.description : ''
                return (
                  <article
                    key={`list-item_${record._source.title}`}
                    className={bemmer.element('list-item')}>
                    <Link to={record._source.filename.replace('/content', '').replace('.md', '')}>
                      <h4>{record._source.title}</h4>
                    </Link>
                    <h6>last updated: {lastUpdated ? `${lastUpdated.toLocaleDateString("en-GB")}` : null}</h6>
                    <p className='description'>{description.replace('#', '')}</p>
                  </article>
                )
              }) }
              </section>
            </section>
          )

  }

  render() {
    const { location, curMenuState } = this.props
    const bemmer = bem('searchpage')

    return (
      <PageWrapper isSidebarOpen={curMenuState}>
        <HtmlHead title='Search' />
        <PageContent className={bemmer.element('content')}>
          <PageSection>
            <Searchbar location={location} />
            { this._displayFound({bemmer}) }
          </PageSection>
        </PageContent>
        <Footer />
      </PageWrapper>

    )
  }
}



// WEBPACK FOOTER //
// ./component/page/SearchPage/SearchPage.js